import React from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";

import { FilledButton } from "@jsluna/button";

import {
  Notification,
  NotificationStatuses,
} from "@jsainsburyplc/id-ui-common";

import { resendVerifyTokenAction } from "actions/resendVerifyToken.action";
import { FAILURE_MESSAGE, TRY_AGAIN } from "constants/messages";

import PageFormat from "../../PageFormat";

class ActivateAccount extends React.Component {
  static type = "ActivateAccount";

  constructor(props) {
    super(props);
    this.state = {
      email: this.props.email,
    };
  }

  handleResendActivationClick = () => {
    const { dispatch } = this.props;
    this.setState({
      buttonDisabled: true,
    });
    dispatch(resendVerifyTokenAction.resendFromLogin(this.props.email));
  };

  static getDerivedStateFromProps(nextProps, state) {
    if (nextProps.error) {
      state.error = nextProps.error;
      state.buttonDisabled = false;
    } else if (nextProps.success) {
      state.success = nextProps.success;
    }
    return state;
  }

  render() {
    return (
      <PageFormat>
        <div className="c-hero c-hero--center">
          <h3>You need to activate your {this.props.missionName} account</h3>
        </div>
        <div className="ln-u-soft ln-u-text-align-center">
          <Notification>
            Your account needs to be activated in order to login.
            <br />
            To do this, click the link in the email we sent you after
            registering.
          </Notification>
          <br />
          <FilledButton
            id="submit"
            type="submit"
            disabled={this.state.buttonDisabled}
            onClick={this.handleResendActivationClick}
            fullWidth
          >
            Resend verification link
          </FilledButton>
          {this.state.success || this.state.error ? (
            <div>
              <div className="ln-c-card ln-c-card--soft">
                {this.state.success ? (
                  <Notification type={NotificationStatuses.SUCCESS_TYPE}>
                    Email has been resent.
                  </Notification>
                ) : this.state.error ? (
                  <Notification type={NotificationStatuses.ERROR_TYPE}>
                    {FAILURE_MESSAGE} {TRY_AGAIN}
                  </Notification>
                ) : null}
              </div>
            </div>
          ) : null}
        </div>
      </PageFormat>
    );
  }
}
ActivateAccount.propTypes = {
  resendToken: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  const { sending, error, success } = state.resendTokenFromLogin;
  return {
    sending,
    error,
    success,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    resendToken: (email) =>
      dispatch(resendVerifyTokenAction.resendFromLogin(email)),
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivateAccount);
